import type { Game } from '../../game/Game';
import { registerPanel } from '../../ui/app/App';
import { LifeSkillOverlay } from './LifeSkillOverlay';
import { hideDepletedNodes, installKeyCapture, lifeGame, lifeSkillSystem, startGather } from './session';
import './lifeskills.css';

/**
 * Life skills: foraging, logging, mining, fishing and excavating mini-games on
 * world interactables (G), plus hunting (hides carved from slain beasts).
 */

let installedOn: Game | null = null;
let removeKeys: (() => void) | null = null;

export function install(game: Game): void {
  if (installedOn === game) return;
  installedOn = game;
  lifeGame.current = game;
  registerPanel('lifeskill', LifeSkillOverlay);
  for (const kind of ['gather', 'fish', 'dig'] as const) {
    const prev = game.interactHandlers.get(kind);
    game.interactHandlers.set(kind, (g, id) => startGather(g, id) || (prev?.(g, id) ?? false));
  }
  game.systems.push(lifeSkillSystem);
  game.zoneSetups.push((_g, z) => hideDepletedNodes(z));
  removeKeys?.();
  removeKeys = installKeyCapture(game);
}

export { NODES, SKILL_INFO, energyCost, nodeFor, rollYield, yieldTable, rareChanceFor, huntYield, lifeXpFor } from './data';
export { lifeSession, startGather, abortGather } from './session';
export { playOnce, PlayerClipLoop } from './anim';
